import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class AngusIntegrationBadSetupError extends CodedError {
  static get errorName() {
    return errorCodes.angusIntegrationBadSetup.code;
  }

  constructor(message: string = errorCodes.angusIntegrationBadSetup.message) {
    super(message);
    this.code = errorCodes.angusIntegrationBadSetup.code;
    this.message = `${message} ${errorCodes.angusIntegrationBadSetup.code}`;
    this.name = errorCodes.angusIntegrationBadSetup.name;
  }
}
